import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEmbedMode } from '@infl-ts/util-embed-mode-provider';
import { usePageEventsTracker } from '@infl-ts/util-page-events-tracker';
import * as D from '@nll/datum/lib/Datum';
import * as DE from '@nll/datum/lib/DatumEither';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { absurd, constUndefined, flow, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as t from 'io-ts';
import { parse } from 'qs';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import AdvocateWorkflow from './advocate-workflow';
import ApiIntegration from './api-integration';
import Checkin from './checkin';
import CorporateApproval from './corporate-approval';
import DiscussionReply from './discussion-reply';
import FileUpload from './file-upload';
import G2Review from './g2-review';
import ImageUpload from './image-upload';
import JoinGroup from './join-group';
import NetPromoterScoreStage from './net-promoter-score';
import OnlineStage from './online-stage';
import Questions from './questions';
import Quiz from './quiz';
import SocialShare from './social-share';
import TwitterFollow from './twitter-follow';
import TwitterPost from './twitter-post';
import TwitterReply from './twitter-reply';
import { UpdateProfile } from './update-profile';
import VideoUpload from './video-upload';
import { jsx as _jsx } from "react/jsx-runtime";
export var PureStageContent = function PureStageContent(_ref) {
  var stage = _ref.stage,
      profile = _ref.profile,
      stageCompleteProps = _ref.stageCompleteProps,
      stageGeneralProps = _ref.stageGeneralProps,
      isPreview = _ref.isPreview;
  if (stage.__typename === 'AdvocateAcceptanceStage') return /*#__PURE__*/_jsx(AdvocateWorkflow, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));
  if (stage.__typename === 'ApiIntegrationStage') return /*#__PURE__*/_jsx(ApiIntegration, _objectSpread({
    stage: stage
  }, stageGeneralProps));
  if (stage.__typename === 'CheckInStage') return /*#__PURE__*/_jsx(Checkin, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));
  if (stage.__typename === 'CorporateConfirmationStage') return /*#__PURE__*/_jsx(CorporateApproval, _objectSpread({
    stage: stage
  }, stageGeneralProps));
  if (stage.__typename === 'InfluitiveGroupJoinStage') return /*#__PURE__*/_jsx(JoinGroup, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));
  if (stage.__typename === 'NpsStage') return /*#__PURE__*/_jsx(NetPromoterScoreStage, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));

  if (stage.__typename === 'OnlineActionStage') {
    return /*#__PURE__*/_jsx(OnlineStage, _objectSpread(_objectSpread({
      stage: stage,
      incompleteTooltipText: "You must first visit the site"
    }, stageGeneralProps), stageCompleteProps));
  }

  if (stage.__typename === 'ReviewStage') {
    return /*#__PURE__*/_jsx(OnlineStage, _objectSpread(_objectSpread({
      stage: stage,
      incompleteTooltipText: "You must first submit online review"
    }, stageGeneralProps), stageCompleteProps));
  }

  if (stage.__typename === 'G2ReviewStage') return /*#__PURE__*/_jsx(G2Review, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));
  if (stage.__typename === 'QuestionsStage') return /*#__PURE__*/_jsx(Questions, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));

  if (stage.__typename === 'TwitterPostStage' || stage.__typename === 'TwitterFollowStage') {
    var twitterProps = _objectSpread(_objectSpread(_objectSpread({}, stageGeneralProps), stageCompleteProps), {}, {
      twitterAccount: pipe(profile.socialAccounts, A.findFirst(function (social) {
        return social.__typename === 'Twitter';
      }), O.toNullable),
      isPreview: isPreview
    });

    if (stage.__typename === 'TwitterFollowStage') return /*#__PURE__*/_jsx(TwitterFollow, _objectSpread({
      stage: stage
    }, twitterProps));
    if (stage.contentType === 'reply') return /*#__PURE__*/_jsx(TwitterReply, _objectSpread({
      stage: stage
    }, twitterProps));
    return /*#__PURE__*/_jsx(TwitterPost, _objectSpread({
      stage: stage
    }, twitterProps));
  }

  if (stage.__typename === 'FileUploadStage') return /*#__PURE__*/_jsx(FileUpload, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));
  if (stage.__typename === 'ImageUploadStage') return /*#__PURE__*/_jsx(ImageUpload, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));

  if (stage.__typename === 'QuizStage') {
    return /*#__PURE__*/_jsx(Quiz, _objectSpread(_objectSpread({
      stage: stage,
      profileId: profile.id,
      isPreview: isPreview
    }, stageGeneralProps), stageCompleteProps));
  }

  if (stage.__typename === 'ShareLinkStage' || stage.__typename === 'ReferralSocialShareStage') {
    return /*#__PURE__*/_jsx(SocialShare, _objectSpread(_objectSpread({
      stage: stage,
      profile: profile,
      isPreview: isPreview
    }, stageGeneralProps), stageCompleteProps));
  }

  if (stage.__typename === 'VideoUploadStage') return /*#__PURE__*/_jsx(VideoUpload, _objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps));
  if (stage.__typename === 'DiscussionReplyStage') return /*#__PURE__*/_jsx(DiscussionReply, _objectSpread({
    stage: stage
  }, stageGeneralProps));
  if (stage.__typename === 'UpdateProfileStage') return /*#__PURE__*/_jsx(UpdateProfile, _objectSpread(_objectSpread(_objectSpread({
    stage: stage
  }, stageGeneralProps), stageCompleteProps), {}, {
    profile: profile
  }));
  return absurd(stage);
};
var ChallengeParams = t.type({
  platform: t.string
});

var useProps = function useProps(_ref2) {
  var stage = _ref2.stage,
      activity = _ref2.activity,
      profile = _ref2.profile,
      _completeStage = _ref2.completeStage,
      completeStageStatus = _ref2.completeStageStatus,
      isOnboarding = _ref2.isOnboarding,
      isPreview = _ref2.isPreview,
      prospect = _ref2.prospect;

  var _useState = useState(completeStageStatus),
      cachedStageStatus = _useState[0],
      setCachedStageStatus = _useState[1];

  var _usePageEventsTracker = usePageEventsTracker(),
      startActivity = _usePageEventsTracker.startActivity;

  var location = useLocation();
  var platform = useEmbedMode().platform || pipe(location.search, function (searchParams) {
    return parse(searchParams, {
      ignoreQueryPrefix: true
    });
  }, function (parsedParams) {
    return ChallengeParams.decode(parsedParams);
  }, E.matchW(constUndefined, function (params) {
    return params.platform;
  }));
  useEffect(function () {
    return setCachedStageStatus(function (prevStatus) {
      return DE.isInitial(prevStatus) && DE.isRepleteRight(completeStageStatus) ? prevStatus : completeStageStatus;
    });
  }, [completeStageStatus, stage.id]);
  useEffect(function () {
    setCachedStageStatus(D.initial);
    return startActivity(isOnboarding ? 'Challenge Onboarding' : 'Challenge', "Stage ".concat(stage.position + 1, ": ").concat(stage.name));
  }, [stage, activity === null || activity === void 0 ? void 0 : activity.id]);
  return {
    stage: stage,
    stageGeneralProps: {
      activity: activity !== null && activity !== void 0 ? activity : null,
      prospect: prospect
    },
    stageCompleteProps: {
      completeStageStatus: cachedStageStatus,
      completeStage: function completeStage(input) {
        return _completeStage({
          variables: {
            input: _objectSpread(_objectSpread({}, input), {}, {
              platform: platform
            })
          }
        });
      }
    },
    profile: profile,
    isPreview: isPreview
  };
};

export default Object.assign(flow(useProps, PureStageContent), {
  displayName: 'StageContent'
});